function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProcedures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1499",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/procedures"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 232",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1223",
    d: "M16409.336 13327.775a.632.632 0 0 1-.639-.638v-2.594a.634.634 0 0 1 .639-.64h5.1a.631.631 0 0 1 .639.64v2.594a.63.63 0 0 1-.639.638zm1.914-5.046v-.1h-7.02a.631.631 0 0 1-.637-.64v-.737a.638.638 0 0 1 1.275 0v.1h14.037v-.1a.638.638 0 0 1 1.275 0v.737a.633.633 0 0 1-.637.64h-7.02v.1a.638.638 0 1 1-1.275 0zm5.742-2.652a.637.637 0 0 1-.639-.638v-2.551a.638.638 0 0 1 .639-.638h5.146a.636.636 0 0 1 .637.638v2.551a.635.635 0 0 1-.637.638zm-15.355 0a.636.636 0 0 1-.639-.638v-2.551a.637.637 0 0 1 .639-.638h5.146a.638.638 0 0 1 .639.638v2.551a.637.637 0 0 1-.639.638zm9.8-2.576-2.721-2.718a.647.647 0 0 1 0-.893l2.721-2.72a.649.649 0 0 1 .893 0l2.721 2.72a.643.643 0 0 1 0 .893l-2.721 2.718a.649.649 0 0 1-.893 0zm7.465-2.426v-.1h-2.494a.637.637 0 1 1 0-1.274h3.133a.637.637 0 0 1 .637.638v.738a.638.638 0 0 1-1.275 0zm-15.312 0v-.738a.64.64 0 0 1 .637-.638h3.137a.637.637 0 0 1 0 1.274h-2.5v.1a.638.638 0 0 1-1.275 0zm7.658-5.206h-1.916a.633.633 0 0 1-.639-.638v-2.594a.634.634 0 0 1 .639-.64h5.1a.632.632 0 0 1 .639.64v2.594a.63.63 0 0 1-.639.638h-1.916a.638.638 0 0 1-1.271 0z",
    transform: "translate(-16397.889 -13302.889)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcedures);
export default __webpack_public_path__ + "static/media/icon_procedures.e7d3d927.svg";
export { ForwardRef as ReactComponent };